// Type guard for MutationDateTimeMarkupField
export function isMutationDateTimeMarkupField(mutation) {
  return mutation.dateTime !== undefined;
}